import { createContext } from "react";

import { OnCcpInitCallback } from "../connect/api";

/** Context that allows to obtain the `onCcpInit` callback. */
export const OnCcpInitContext = createContext<OnCcpInitCallback | undefined>(
  undefined
);
